<template>
    <span>
         <span v-if="this.type === 'DIL'">
             <span v-if="this.translation">
                 {{this.translation.label_tipologia.toUpperCase()}}
             </span>
             <span v-else>
                 {{$t('dil')}}
             </span>
        </span>
        <span v-else-if="this.type === 'MANGIA_RISTORANTE'">
            {{$t('eat_at_restaurant').toUpperCase()}}
        </span>
        <span v-else-if="this.type === 'TAKEAWAY'">
            {{$t('takeaway').toUpperCase()}}
        </span>
        <span v-else-if="this.type === 'DELIVERY'">
            {{$t('delivery').toUpperCase()}}
        </span>
        <span v-else-if="this.type === 'ORDINA_TAVOLO'">
            {{$t('al_tavolo').toUpperCase()}}
        </span>
        <span v-else>
            {{order.tipo_ordine}}
        </span>
    </span>
</template>

<script>
export default {
    name: "IncOrderType",
    props: ['type', 'translation']
}
</script>
